import React from 'react';
import { Row } from 'react-table';
import { useQuery } from '@apollo/client';

import { constants } from '@trqk/utils';
import { queryStrings } from '@trqk/resolvers';
import { LogDetails } from './LogDetails';

const { LOG_NULL_USER_ID } = constants;
const { DOWNLOAD_FROM_S3 } = queryStrings;

interface JsonViewerArgs {
    bucketName: string;
    bucketRegion: string;
    identityPoolId: string;
    selected: Row<LogEvent>;
}

export const JsonViewer = ({
    bucketName,
    bucketRegion,
    identityPoolId,
    selected,
}: JsonViewerArgs): JSX.Element => {
    const s3DownloadResult = useQuery(DOWNLOAD_FROM_S3, {
        variables: {
            bucketName,
            bucketRegion,
            identityPoolId,
            key: selected.original.key.trim().replace(LOG_NULL_USER_ID, ''), // Workaround for S3 keys with empty string as user ID
        },
    });

    return (
        <div className="w-full p-4">
            {s3DownloadResult.data && (
                <LogDetails logData={s3DownloadResult.data.downloadFromS3} />
            )}
        </div>
    );
};
